import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=0feb3df0&"
var script = {}
import style0 from "./dashboard.vue?vue&type=style&index=0&id=0feb3df0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports